import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './UserMenu.css';

const UserMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const { user, logout, isGuest } = useAuth();

  // 点击外部关闭菜单
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // 处理菜单项点击
  const handleMenuClick = (path) => {
    setIsOpen(false);
    if (path === 'logout') {
      handleLogout();
    } else {
      navigate(path);
    }
  };

  // 退出登录
  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  // 获取用户头像首字母
  const getInitials = () => {
    if (isGuest) {
      return '游';
    }
    if (user?.username) {
      return user.username.charAt(0).toUpperCase();
    }
    return 'U';
  };

  // 处理用户按钮点击
  const handleUserClick = () => {
    if (isGuest) {
      navigate('/login');
    } else {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div className="user-menu-container" ref={menuRef}>
      <button 
        className="user-menu-trigger"
        onClick={handleUserClick}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <div className="user-avatar">{getInitials()}</div>
        <span className="user-name">{isGuest ? '游客模式' : (user?.username || '用户')}</span>
        {!isGuest && <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>}
      </button>

      {isOpen && !isGuest && (
        <div className="user-dropdown-menu">
          <div className="dropdown-header">
            <div className="dropdown-avatar">{getInitials()}</div>
            <div className="dropdown-user-info">
              <div className="dropdown-username">{user?.username}</div>
              <div className="dropdown-email">{user?.email}</div>
            </div>
          </div>
          
          <div className="dropdown-divider"></div>
          
          <div className="dropdown-items">
            <button 
              className="dropdown-item"
              onClick={() => handleMenuClick('/profile')}
            >
              <span className="item-icon">👤</span>
              <span>个人资料</span>
            </button>
            
            <button 
              className="dropdown-item"
              onClick={() => handleMenuClick('/settings')}
            >
              <span className="item-icon">⚙️</span>
              <span>账户设置</span>
            </button>
            
            <button 
              className="dropdown-item"
              onClick={() => handleMenuClick('/change-password')}
            >
              <span className="item-icon">🔐</span>
              <span>修改密码</span>
            </button>
          </div>
          
          <div className="dropdown-divider"></div>
          
          <button 
            className="dropdown-item logout-item"
            onClick={() => handleMenuClick('logout')}
          >
            <span className="item-icon">🚪</span>
            <span>退出登录</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
